import React from 'react';
import { Select, MenuItem, FormControl, InputLabel, Box, Button } from '@material-ui/core';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { da } from 'date-fns/locale';
import { WarningFilter, SummaryFilter, CustomDateRange } from '../hooks/useFilters';

interface FilterBarProps {
  warningFilter: WarningFilter;
  setWarningFilter: (filter: WarningFilter) => void;
  summaryFilter: SummaryFilter | null;
  customDateRange: CustomDateRange | null;
  setCustomDateRange: (range: CustomDateRange | null) => void;
  onClearCustomDateRange: () => void;
}

export const FilterBar: React.FC<FilterBarProps> = ({
  warningFilter,
  setWarningFilter,
  summaryFilter,
  customDateRange,
  setCustomDateRange,
  onClearCustomDateRange,
}) => (
  <Box display="flex" justifyContent="flex-start" alignItems="center" style={{ gap: 24, marginBottom: 4, flexWrap: 'wrap' }}>
    <FormControl variant="outlined" style={{ minWidth: 300 }}>
      <InputLabel>Filter on release warnings</InputLabel>
      <Select
        value={warningFilter}
        onChange={(e) => setWarningFilter(e.target.value as WarningFilter)}
        disabled={!!summaryFilter}
      >
        <MenuItem value="no-filter">No filtering</MenuItem>
        <MenuItem value="acceptance">Acceptance warnings (test/acceptance diff)</MenuItem>
        <MenuItem value="production">Production warnings (acceptance/production diff)</MenuItem>
        <MenuItem value="staged">Services with staged releases</MenuItem>
      </Select>
    </FormControl>

    {/* Date Picker Controls */}
    <Box display="flex" alignItems="center" style={{ gap: 8, flexWrap: 'wrap' }}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={da}>
        <DatePicker
          label="From"
          value={customDateRange?.from ? new Date(customDateRange.from) : null}
          onChange={(newValue) => {
            if (newValue) {
              setCustomDateRange({
                from: newValue.toISOString().split('T')[0],
                to: customDateRange?.to || ''
              });
            }
          }}
          slotProps={{ textField: { size: 'small' } }}
        />
      </LocalizationProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={da}>
        <DatePicker
          label="To"
          value={customDateRange?.to ? new Date(customDateRange.to) : null}
          onChange={(newValue) => {
            if (newValue) {
              setCustomDateRange({
                from: customDateRange?.from || '',
                to: newValue.toISOString().split('T')[0]
              });
            }
          }}
          slotProps={{ textField: { size: 'small' } }}
        />
      </LocalizationProvider>
      <Button
        variant="outlined"
        onClick={onClearCustomDateRange}
        disabled={!customDateRange?.from && !customDateRange?.to}
        size="small"
      >
        Clear
      </Button>
    </Box>
  </Box>
); 